import React from "react";
import styles from "./style.module.css";

const VStack = ({
  children,
  spacing = 0,
  gap,
  align = "stretch",
  justify = "flex-start",
  className,
  padding,
  paddingX,
  paddingY,
  paddingTop,
  paddingBottom,
  paddingLeft,
  paddingRight,
  ...props
}) => {
  const getPaddingValue = (value) => {
    return typeof value === "number" ? `${value}px` : value;
  };

  const getGapValue = () => {
    if (gap !== undefined) {
      return typeof gap === "number" ? `${gap}px` : gap;
    }
    return typeof spacing === "number" ? `${spacing}px` : spacing;
  };

  const style = {
    gap: getGapValue(),
    alignItems: align,
    justifyContent: justify,
    ...(padding !== undefined && { padding: getPaddingValue(padding) }),
    ...(paddingX !== undefined && {
      paddingLeft: getPaddingValue(paddingX),
      paddingRight: getPaddingValue(paddingX),
    }),
    ...(paddingY !== undefined && {
      paddingTop: getPaddingValue(paddingY),
      paddingBottom: getPaddingValue(paddingY),
    }),
    ...(paddingTop !== undefined && {
      paddingTop: getPaddingValue(paddingTop),
    }),
    ...(paddingBottom !== undefined && {
      paddingBottom: getPaddingValue(paddingBottom),
    }),
    ...(paddingLeft !== undefined && {
      paddingLeft: getPaddingValue(paddingLeft),
    }),
    ...(paddingRight !== undefined && {
      paddingRight: getPaddingValue(paddingRight),
    }),
    ...props.style,
  };

  return (
    <div className={`${styles.vstack} ${className || ""}`} style={style}>
      {children}
    </div>
  );
};

export default VStack;
